import { Component, computed, input } from '@angular/core';
import { NgClass, TitleCasePipe } from '@angular/common';

import { badgeVariants, BadgeVariants } from './badge.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: '[role-badge], role-badge',
  standalone: true,
  imports: [NgClass, MatTooltipModule, TitleCasePipe],
  template: `
    @if (
      {
        remainingCount: remainingCount(),
        remainingRolesLabel: remainingRolesLabel()
      };
      as STATE
    ) {
      <span class="flex items-center gap-1">
        <span
          [class]="computedClasses()"
          [ngClass]="{
            'rounded-r-none border-r-0': STATE.remainingCount > 0,
            'rounded-r-[4px]': STATE.remainingCount === 0
          }"
        >
          <ng-content />
        </span>

        @if (STATE.remainingCount > 0) {
          <span
            [matTooltip]="STATE.remainingRolesLabel | titlecase"
            [class]="computedClasses()"
          >
            +{{ STATE.remainingCount }}
          </span>
        }
      </span>
    }
  `
})
export class RoleBadgeComponent {
  roles = input<string[]>([]);
  variant = input<BadgeVariants['variant']>('info');
  size = input<BadgeVariants['size']>('default');
  selected = input<string | null | undefined>(undefined);

  remainingCount = computed(() => {
    const totalRoles = this.roles().length;
    return totalRoles > 1 ? totalRoles - 1 : 0;
  });

  remainingRolesLabel = computed(() => {
    const selected = this.selected();
    if (!selected) return '';
    return this.roles()
      .filter(el => el.toLocaleLowerCase() !== selected.toLocaleLowerCase())
      .join(', ');
  });

  computedClasses = computed(() =>
    badgeVariants({
      variant: this.variant(),
      size: this.size()
    })
  );
}
